export type Testimonial = {
	id: number;
	title: string;
	quote: string;
	author: string;
	position: string;
	company: string;
};

export const testimonials: Testimonial[] = [
	{
		id: 1,
		title: 'Relentless Attention to Detail',
		quote:
			"What sets JovianCloudWorks apart is their relentless attention to detail. They catch the things everyone else misses—the subtle assumptions and edge cases that quietly derail a build months later. Time and again, they've surfaced a discrepancy or a definitional gap that we would have carried forward unknowingly.",
		author: 'Corey Wann',
		position: 'Managing Consultant',
		company: 'Katana Research',
	},
	{
		id: 2,
		title: 'A Business-Process-First Approach',
		quote:
			"Just as impressive is their business-process-first approach to application design. They don't start with the technology—they start by deeply understanding how the business actually works, then design systems that fit those processes rather than forcing us to bend around the software. The result: solutions that feel intuitive and that people actually adopt.",
		author: 'Corey Wann',
		position: 'Managing Consultant',
		company: 'Katana Research',
	},
	{
		id: 3,
		title: 'A Partner You Can Trust',
		quote:
			'Working with JovianCloudWorks has been one of the best decisions our organization has ever made. They are professional, responsive, and patient—insightful and rigorous—helping us avoid missteps and keep the project grounded and on track. Honestly, I would be lost without their guidance.',
		author: 'Corey Wann',
		position: 'Managing Consultant',
		company: 'Katana Research',
	},
];
